import * as _ from 'lodash'
import * as Services from "../../../Services";
import * as toastr from "toastr";


export interface IBypassILAbpDisclosureEventScope extends ng.IScope {
    bypassILAbpDisclosureEventCtrl: BypassILAbpDisclosureEventController;
}

export class BypassILAbpDisclosureEventController {
    public static $inject = ['$state', '$scope', '$modalInstance', 'CustomerApiClient', 'igsCustomerNumber'];

    constructor(
        public $state: angular.ui.IStateService,
        public $scope: IBypassILAbpDisclosureEventScope,
        public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
        private customerApiClient: Services.CustomerApiClient.ICustomerApiClient,
        private igsCustomerNumber: string,
    ) {
        $scope.bypassILAbpDisclosureEventCtrl = this;
    }

    public submitBypass = () => {
        this.customerApiClient
            .submitCustomerEventBypass(this.igsCustomerNumber, 'IncProDisclosure')
            .then(() => {
                toastr.success(
                    "Success",
                    "The IL ABP Disclosure event was successfully bypassed.",
                );
                this.$modalInstance.close();
                this.$state.reload();
            })
            .catch(() => {
                toastr.error(
                    "Error",
                    "Something went wrong trying to process your request.",
                );
                this.$modalInstance.close();
            })
    }

    public closeModal = () => {
        this.$modalInstance.close();
    }
}
